






import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
class LibraryIcon extends Vue {
  @Prop() name: string;
}
export default LibraryIcon;
